<template>
	<nav>
		<paginate
			v-if="pageCount"
			:page-count="pageCount"
			:page-range="3"
			:click-handler="onClick"
			prev-text="«"
			next-text="»"
			container-class="pagination justify-content-center"
			next-class="page-item"
			next-link-class="page-link"
			prev-class="page-item"
			prev-link-class="page-link"
			page-class="page-item"
			page-link-class="page-link">
		</paginate>
		<div class="small text-center">{{ fromItem }} - {{ toItem }} от {{ total }}</div>
	</nav>
</template>

<script>
var Vue = require('vue');
var Paginate = require('vuejs-paginate');
Vue.component('paginate', Paginate);

module.exports = {
	name: 'f-pager',
	props: ['total', 'clickhandler'],
	data: () => ({
		page: 1
	}),
	computed: {
		pageCount () {
			return Math.ceil(this.total / this.$config.rpp);
		},
		fromItem () {
			return Math.min((this.page - 1) * this.$config.rpp + 1, this.total);
		},
		toItem () {
			return Math.min(this.page * this.$config.rpp, this.total);
		},
	},
	methods: {
		onClick (p) {
			this.page = p;
			this.clickhandler(p);
		}
	}
};
</script>



// WEBPACK FOOTER //
// f-pager.vue?187ed606